import { render, staticRenderFns } from "./cancelledOrders.vue?vue&type=template&id=61d8312a"
import script from "./cancelledOrders.vue?vue&type=script&lang=js"
export * from "./cancelledOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports